import { render } from "./WidgetOrdersMonthly.vue?vue&type=template&id=681a0848&scoped=true&ts=true"
import script from "./WidgetOrdersMonthly.vue?vue&type=script&lang=ts"
export * from "./WidgetOrdersMonthly.vue?vue&type=script&lang=ts"

import "./WidgetOrdersMonthly.vue?vue&type=style&index=0&id=681a0848&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681a0848"]])

export default __exports__